import { useMutation } from '@tanstack/react-query';
import { newAttemptRevision } from '../queries/post';

export function useFinishWithAttemptRevision() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['finishWithAttemptRevision'], 
    mutationFn: (id: string) => newAttemptRevision(id),
    retry: false
  });

  return { mutate, data, isPending, isSuccess };
}
